import {SummaryModel} from "../../../../common/entity/summary.model";
import {PermissionsModel} from "../../../../common/entity/permissions.model";

export class InsoleMaterialSummaryModel  implements SummaryModel {
    id: number;
    permissions: PermissionsModel;
    label: string;
    active: boolean;
    forPrinting: boolean;
    forDrilling: boolean;
    forManual: boolean;
}